import React, { useState, memo } from 'react'
import Navbar from '../../../components/Navbar'
import { connect } from 'react-redux'
import setRedirectUrl from '../../../redux/actions/redirection/setRedirectUrl'

import { Button, Container, Box, TextField, useMediaQuery, useTheme, styled, IconButton } from '@mui/material'
import MultiSelectTreeView from './components/treeView/treeView'

import useFilters from './hooks/filters'
import CreaRubro from './widgets/CreaRubro'
import Footer from '../../Home/components/Footer'
import useRubros from '../../Products/hooks/rubros.hook'
import { useDataABMRubros } from './services/datos.seleccion'
import { RolType } from '../../../components/Navbar/Sidebar/SidebarItems'

export const Header = styled('div')({
  display: 'flex',
  justifyContent: 'space-between'
})

const AbmRubrosPage = (props: any) => {
  const isAdmin = props.logged.userLogged.roles.includes(RolType.ADMIN || RolType.MOD)
  const { rubros, updateRubros, flatRubros } = useRubros()
  const { monedas, unidadesDeMedidaDisponibles, gruposAtr } = useDataABMRubros(isAdmin)
  const { setSearchFilter } = useFilters(rubros)

  const [tmpSearchFilter, setTmpSearchFilter] = useState('')
  const [modalNewRubro, setModalNewRubro] = useState<boolean>(false)
  const [expandedNodes, setExpandedNodes] = useState<string[]>([])
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const executeSearch = () => {
    setSearchFilter(tmpSearchFilter)
  }

  return (
    <>
      <Navbar title="ABM de Rubros" />
      <Container>
        <Box
          sx={{
            width: '100%',
            marginTop: '2vh',
            display: 'flex',
            gap: '10px',
            flexDirection: isMobile ? 'column' : 'row'
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
            <TextField
              id="outlined-basic"
              style={{ flexGrow: 1 }}
              label="Buscar por nombre o descripción"
              onChange={(e: any) => setTmpSearchFilter(e.target.value)}
              onKeyPress={(e: any) => e.key === 'Enter' && executeSearch()}
              variant="outlined"
              fullWidth={isMobile}
            />
          </div>
          <Button variant="contained" onClick={executeSearch}>
            Buscar
          </Button>
          <Button
            variant="contained"
            fullWidth={isMobile}
            color="success"
            onClick={() => {
              setModalNewRubro(true)
            }}
          >
            Agregar nuevo rubro
          </Button>
        </Box>

        <div className="p-4">
          <MultiSelectTreeView
            rubros={rubros}
            flatRubros={flatRubros}
            monedas={monedas}
            unidadesDeMedida={unidadesDeMedidaDisponibles}
            gruposAtr={gruposAtr}
            searchedRubro={tmpSearchFilter}
            updateRubros={updateRubros}
            expandedNodes={expandedNodes}
            setExpandedNodes={setExpandedNodes}
          />
        </div>
        <CreaRubro
          open={modalNewRubro}
          setOpen={setModalNewRubro}
          rubros={flatRubros}
          monedas={monedas}
          unidadesDeMedida={unidadesDeMedidaDisponibles}
          gruposAtr={gruposAtr}
          updateRubros={updateRubros}
        />
      </Container>
      <Footer />
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection
  }
}

const mapDispatchToProps = {
  setRedirectUrl
}

export default connect(mapStateToProps, mapDispatchToProps)(memo(AbmRubrosPage))
